import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { reduce } from './nodes';
var TextSerializer = /*#__PURE__*/function () {
  function TextSerializer(schema) {
    _classCallCheck(this, TextSerializer);
    this.schema = schema;
    this.schema = schema;
  }
  return _createClass(TextSerializer, [{
    key: "serializeFragment",
    value: function serializeFragment(fragment) {
      var _this = this;
      var result = [];
      fragment.forEach(function (n) {
        result.push(reduce(n, _this.schema));
      });

      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      return result.join('\n').replace(/\n+/g, '\n');
    }
  }], [{
    key: "fromSchema",
    value: function fromSchema() {
      var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSchema;
      return new TextSerializer(schema);
    }
  }]);
}();
export { TextSerializer as default };